import { FaCalendarAlt, FaUsers, FaGift, FaComments, FaIndustry, FaHandshake, FaSmile, FaCheck } from "react-icons/fa";

const HowSessionsWorkSection = () => {
    const sessionCards = [
        {
            id: 1,
            title: "Every Weekend",
            subtitle: "Saturday & Sunday, 10 AM – 12 PM IST",
            points: [
                "2-hour focused sessions",
                "Live coding demonstrations",
                "Q&A at the end of each session",
            ],
            icon: FaCalendarAlt,
        },
        {
            id: 2,
            title: "Interactive Format",
            subtitle: "Learn by doing, not just watching",
            points: [
                "Code along with me in real-time",
                "Ask questions anytime during session",
                "Share your screen for code reviews",
            ],
            icon: FaUsers,
        },
    ];

    const differenceCards = [
        {
            id: 1,
            title: "100% Free",
            desc: "No hidden costs, no upsells, ever",
            icon: FaGift,
        },
        {
            id: 2,
            title: "Open Discussion",
            desc: "Bring your doubts, share your code",
            icon: FaComments,
        },
        {
            id: 3,
            title: "Industry Focus",
            desc: "Real practices from real companies",
            icon: FaIndustry,
        },
        {
            id: 4,
            title: "No Pressure",
            desc: "Learn at your pace, no judgments",
            icon: FaHandshake,
        },
    ];

    return (
        <section className="row mx-0 justify-content-center my-5 py-5">
            <div className="col-12 col-md-10">
                <div className="row mx-0 text-center mb-5">
                    <div className="col-12">
                        <h1 className="fw-bold">How Our Sessions Work</h1>
                        <p>
                            No recordings to watch alone. No pre-recorded content.
                            Just live, interactive sessions every weekend.
                        </p>
                    </div>
                </div>

                <div className="row mx-0 d-flex align-items-center my-5">
                    {sessionCards.map((item) => {
                        const Icon = item.icon;
                        return (
                            <div className="col-12 col-md-6" key={item.id}>
                                <div className="p-4 my-2 radius-10 h-100 border bg-light shadow-sm">
                                    <div className="d-flex align-items-center">
                                        <div className="text-custom mr-3">
                                            <Icon size={32} />
                                        </div>
                                        <h5 className="fw-bold mb-0">{item.title}</h5>
                                    </div>
                                    <p className="text-muted mb-3">{item.subtitle}</p>
                                    <ul className="list-unstyled mb-0">
                                        {item.points.map((point, index) => (
                                            <li key={index} className="mb-2">
                                                <FaCheck size={16} className="text-custom mr-2" /> {point}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="row mx-0 justify-content-center">
                    <div className="col-12">
                        <div className="p-4 p-md-5 radius-10 bg-light border shadow-sm">
                            <h4 className="fw-bold text-center mb-4">
                                What Makes These Sessions Different
                            </h4>
                            <div className="row mx-0 text-center">
                                {differenceCards.map((item) => {
                                    const Icon = item.icon;
                                    return (
                                        <div className="col-6 col-md-3" key={item.id}>
                                            <div className="h-100">
                                                <div className="text-custom mx-auto mb-3">
                                                    <Icon size={32} />
                                                </div>
                                                <h6 className="fw-bold">{item.title}</h6>
                                                <p>{item.desc}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowSessionsWorkSection;
